<template>
	<div class="flex flex-col gap-4">
		<div class="flex items-center gap-2">
			<select v-model="selectedLanguage" :disabled="readonly" @change="selectedVoice = undefined">
				<option :value="undefined">-- Select a language --</option>
				<option v-for="language in languages" :key="language" :value="language">
					{{ language }}
				</option>
			</select>
		</div>
		<div v-if="selectedLanguage" class="flex items-center gap-2">
			<select v-model="selectedVoice" :disabled="readonly">
				<option :value="undefined">-- Select a voice --</option>
				<option v-for="voice in languageVoices" :key="voice.name" :value="voice">
					{{ voice.displayName }}
				</option>
			</select>
		</div>
	</div>
</template>

<script>
import filesApi from '@/scripts/files/files.api'

export default {
	props: {
		savedData: {},
		readonly: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			voices: [],
			languages: new Set(),
			selectedVoice: {},
			selectedLanguage: undefined
		}
	},
	computed: {
		languageVoices() {
			return this.voices.filter((v) => v.language === this.selectedLanguage)
		}
	},
	watch: {
		selectedVoice: {
			deep: true,
			handler() {
				this.$emit('update', this.selectedVoice)
			}
		}
	},
	mounted() {
		filesApi
			.getTTSSpec()
			.then((result) => {
				Object.keys(result.providers).map((provider) => {
					result.providers[provider].voices.forEach((voice) => {
						voice.provider = provider
						this.languages.add(voice.language)
						this.voices.push(voice)
					})
				})
			})
			.catch(console.error)

		if (this.savedData) {
			this.selectedVoice = this.savedData
			this.selectedLanguage = this.savedData?.language
		}
	}
}
</script>

<style scoped>
input[type='checkbox'] {
	margin: 0;
}
label {
	padding: 0 0 2px 0;
}
</style>
